/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Newsletter_CtaInputs */

const en_directory_resources_newsletter_cta = /** @type {(inputs: Directory_Resources_Newsletter_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request newsletter access`)
};

const zh_directory_resources_newsletter_cta = /** @type {(inputs: Directory_Resources_Newsletter_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申请订阅 Newsletter`)
};

/**
* | output |
* | --- |
* | "Request newsletter access" |
*
* @param {Directory_Resources_Newsletter_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_newsletter_cta = /** @type {((inputs?: Directory_Resources_Newsletter_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Newsletter_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_newsletter_cta(inputs)
	return zh_directory_resources_newsletter_cta(inputs)
});
export { directory_resources_newsletter_cta as "directory.resources.newsletter.cta" }